import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { downgradeInjectable, downgradeComponent } from '@angular/upgrade/static';

import { SharedModule } from '../shared';

// Components.
import { MenuComponent } from './menu.component';
import { MenuBurgerComponent } from './menu-burger.component';
import { MenuCompileContentComponent } from './compile-content.component';

// Services.
import { MenuService } from './menu.service';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        BrowserAnimationsModule,
        // Third-party modules

        // Shared modules
        SharedModule

        // Current module imports
    ],
    declarations: [
        // Components
        MenuComponent,
        MenuBurgerComponent,
        MenuCompileContentComponent
    ],
    exports: [
        // Components
        MenuComponent
    ],
    providers: [
        MenuService
    ],
    entryComponents: [
        MenuBurgerComponent
    ]
})
export class MenuModule {
}

declare const angular: angular.IAngularStatic;

angular.module('app')
    .factory('MenuService', downgradeInjectable(MenuService) as any);

angular.module('app')
    .directive('app2MenuBurger', downgradeComponent({ component: MenuBurgerComponent }) as any);
